const VALUE_MISSING = "Select an option to continue.";
export default {
  nativeValidationMessages: {
    valueMissing: VALUE_MISSING
  },
  placeholder: "Select",
  requiredErrorMessage: VALUE_MISSING
};